import { useTLang } from 'intl/intl';

export function useMenuBodyLang(props: Props) {
  const { quantityOutOfStock = 0 } = props;

  const outOfStockBtn = useTLang(
    {
      id:
        quantityOutOfStock === 1
          ? 'menuPage.board.nav.outOfStock.btn.singular'
          : 'menuPage.board.nav.outOfStock.btn.plural',
    },
    { quantity: quantityOutOfStock },
  );

  return {
    nav: {
      outOfStock: {
        btn: outOfStockBtn,
      },
      products: {
        btn: useTLang({ id: 'menuPage.board.nav.products.btn' }),
      },
      customGroups: {
        btn: useTLang({ id: 'menuPage.board.nav.customGroups.btn' }),
      },
      searchResults: {
        btn: useTLang({ id: 'menuPage.board.nav.searchResults.btn' }),
      },
    },
  };
}

interface Props {
  quantityOutOfStock: number;
}
